import React from 'react';
import { MessageSquare, Download } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { ZodiacTheme } from './zodiacThemes';
interface OrdersTabProps {
  theme: ZodiacTheme;
  onNavigate: (page: string) => void;
  setActiveTab: (tab: string) => void;
}
export function OrdersTab({
  theme,
  onNavigate,
  setActiveTab
}: OrdersTabProps) {
  return <div className="space-y-6" data-id="element-17744">
      <div className="flex justify-between items-center mb-6" data-id="element-17745">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-17746">
          Заказы (Консультации)
        </h2>
        <Button onClick={() => onNavigate('astrologers')} data-id="element-17747">
          Найти астролога
        </Button>
      </div>

      <div className="space-y-4" data-id="element-17748">
        <Card padding="md" className="border-l-4 border-l-amber-500" data-id="element-17749">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-17750">
            <div className="flex items-start gap-4" data-id="element-17751">
              <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 font-bold flex-shrink-0" data-id="element-17752">
                ЕС
              </div>
              <div data-id="element-17753">
                <div className="flex items-center gap-3 mb-1" data-id="element-17754">
                  <span className="text-sm text-slate-500" data-id="element-17755">Заказ #1042</span>
                  <Badge variant="warning" data-id="element-17756">В работе</Badge>
                </div>
                <h3 className="font-bold text-slate-900" data-id="element-17757">
                  Консультация: Синастрия (Видео)
                </h3>
                <div className="text-sm text-slate-600 mt-1" data-id="element-17758">
                  Астролог: Елена Смирнова • 12 Окт 2024 • 5 000 ₽
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2" data-id="element-17759">
              <Button variant="outline" size="sm" icon={<MessageSquare className="w-4 h-4" data-id="element-17761" />} onClick={() => setActiveTab('chat')} data-id="element-17760">
                Открыть чат
              </Button>
            </div>
          </div>
        </Card>

        <Card padding="md" className="border-l-4 border-l-emerald-500 opacity-80" data-id="element-17762">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-17763">
            <div className="flex items-start gap-4" data-id="element-17764">
              <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center text-amber-700 font-bold flex-shrink-0" data-id="element-17765">
                АК
              </div>
              <div data-id="element-17766">
                <div className="flex items-center gap-3 mb-1" data-id="element-17767">
                  <span className="text-sm text-slate-500" data-id="element-17768">Заказ #0984</span>
                  <Badge variant="success" data-id="element-17769">Завершён</Badge>
                </div>
                <h3 className="font-bold text-slate-900" data-id="element-17770">
                  Натальная карта (Текст)
                </h3>
                <div className="text-sm text-slate-600 mt-1" data-id="element-17771">
                  Астролог: Анна Коваль • 25 Сен 2024 • 3 500 ₽
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2" data-id="element-17772">
              <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-17774" />} data-id="element-17773">
                Скачать отчёт
              </Button>
              <Button variant="ghost" size="sm" data-id="element-17775">
                Оставить отзыв
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}